const User = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 20">
      <path
        data-name="Icon awesome-user-alt"
        d="M10.5 11.812a5.906 5.906 0 1 0-5.906-5.906 5.908 5.908 0 0 0 5.906 5.906zm5.25 1.313h-2.26a7.14 7.14 0 0 1-5.98 0H5.25A5.25 5.25 0 0 0 0 18.375v.656A1.969 1.969 0 0 0 1.969 21h17.062A1.969 1.969 0 0 0 21 19.031v-.656a5.25 5.25 0 0 0-5.25-5.25z"
      />
    </svg>
  );
};

export default User;
